import { render, staticRenderFns } from "./OpeningHours.vue?vue&type=template&id=6f647fe8"
import script from "./OpeningHours.js?vue&type=script&lang=js&external"
export * from "./OpeningHours.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports